$(function () {

  // $(".other-shopping-wrap .detail-inner .other-item h4").dotdotdot({ wrap: "letter" });

  $(".other-shopping-wrap .detail-inner .other-item .int").dotdotdot({ wrap: "letter" });
  
});

// 内页导航
$('.section-header .product-drop .title .closeNavWhite').click(function () {
  // $('.product-drop').removeClass("product-display");
  $('.product-drop').css('height', '0');
  var st = $(window).scrollTop();
  if (st == 0) {
    $('.heder-container').addClass('header-white')
  }
})